export default "__VITE_ASSET__461e2821__"